/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Status_CachedInputs */

const bn_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রাফিক ক্যাশে`)
};

const de_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkehr zwischengespeichert`)
};

const el_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η επισκεψιμότητα αποθηκευμένη στην κρυφή μνήμη`)
};

const en_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Cached`)
};

const es_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tráfico almacenado en caché`)
};

const fr_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafic en cache`)
};

const hi_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैफ़िक कैश्ड`)
};

const hu_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgalom gyorsítótárazva`)
};

const id_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lalu Lintas Di-cache`)
};

const it_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffico memorizzato nella cache`)
};

const ja_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャッシュされたトラフィック`)
};

const ko_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캐시된 트래픽`)
};

const nl_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkeer in cache`)
};

const pl_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buforowany ruch`)
};

const pt_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tráfego em cache`)
};

const ru_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трафик кэшируется`)
};

const sv_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik cachelagrad`)
};

const tr_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik Önbelleğe Alındı`)
};

const uk_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кешований трафік`)
};

const vi_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu lượng truy cập được lưu vào bộ nhớ đệm`)
};

const zh_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流量缓存`)
};

const zh_hant_cipher_status_cached = /** @type {(inputs: Cipher_Status_CachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流量快取`)
};

/**
* | output |
* | --- |
* | "Traffic Cached" |
*
* @param {Cipher_Status_CachedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_status_cached = /** @type {((inputs?: Cipher_Status_CachedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Status_CachedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_status_cached(inputs)
	if (locale === "de") return de_cipher_status_cached(inputs)
	if (locale === "el") return el_cipher_status_cached(inputs)
	if (locale === "en") return en_cipher_status_cached(inputs)
	if (locale === "es") return es_cipher_status_cached(inputs)
	if (locale === "fr") return fr_cipher_status_cached(inputs)
	if (locale === "hi") return hi_cipher_status_cached(inputs)
	if (locale === "hu") return hu_cipher_status_cached(inputs)
	if (locale === "id") return id_cipher_status_cached(inputs)
	if (locale === "it") return it_cipher_status_cached(inputs)
	if (locale === "ja") return ja_cipher_status_cached(inputs)
	if (locale === "ko") return ko_cipher_status_cached(inputs)
	if (locale === "nl") return nl_cipher_status_cached(inputs)
	if (locale === "pl") return pl_cipher_status_cached(inputs)
	if (locale === "pt") return pt_cipher_status_cached(inputs)
	if (locale === "ru") return ru_cipher_status_cached(inputs)
	if (locale === "sv") return sv_cipher_status_cached(inputs)
	if (locale === "tr") return tr_cipher_status_cached(inputs)
	if (locale === "uk") return uk_cipher_status_cached(inputs)
	if (locale === "vi") return vi_cipher_status_cached(inputs)
	if (locale === "zh") return zh_cipher_status_cached(inputs)
	return zh_hant_cipher_status_cached(inputs)
});